var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              attrs: { inline: false, "label-position": "top", size: "small" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticClass: "selectLabel" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: _vm.queryForm.params.selectType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "selectType",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.selectType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      key: "1",
                                      attrs: {
                                        label: _vm.$t("GlobalSetObj.bagNumber"),
                                        value: 1,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "2",
                                      attrs: {
                                        label: _vm.$t(
                                          "GlobalSetObj.licensePlateNumber"
                                        ),
                                        value: 2,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("newOrder.PreciseSearch1"),
                              rows: 1,
                              type: "textarea",
                            },
                            model: {
                              value: _vm.queryForm.params.inputValue,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "inputValue",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.inputValue",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.operationType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.operationType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "operationType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.operationType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("routes.sorterConsolidation"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("routes.manualConsolidation"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("navbar.businessType") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.businessType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "businessType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.businessType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("routes.forwardConsolidation"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("routes.returnConsolidation"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "timeType" } },
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticClass: "selectLabel" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    style: _vm.IsWidth,
                                    model: {
                                      value: _vm.queryForm.params.timeType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "timeType",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.timeType",
                                    },
                                  },
                                  _vm._l(_vm.timeLable, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.label,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: false,
                              "default-time": ["00:00:00", "23:59:59"],
                              format:
                                _vm.$i18n.locale == "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              placeholder: _vm.$t("newOrder.SelectDatetime"),
                              "range-separator": "~",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("routes.consolidationOperationHub"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                "remote-method": _vm.remoteGetSiteList,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.remoteGetSiteList("")
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.operationSiteId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "operationSiteId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.operationSiteId",
                              },
                            },
                            _vm._l(_vm.preDeliverySiteList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "28px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-search",
                              size: "small",
                              type: "primary",
                            },
                            on: { click: _vm.enterSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-refresh-left",
                              size: "small",
                              type: "info",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.resetForm()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.allExportOrder(1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("collectionCenter.export1")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.allExportOrder(2)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("collectionCenter.allExport")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              ref: "tableRef",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
                "row-key": "id",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "reserve-selection": true,
                  align: "center",
                  fixed: "left",
                  type: "selection",
                  width: "50",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.id,
                  attrs: {
                    align: item.center,
                    label: item.label,
                    "min-width": item.cloWidth,
                    prop: item.prop,
                    "show-overflow-tooltip": false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "packageCount"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "textOperator",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePackageDetail(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.packageCount || 0) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row[item.prop]
                                        ? "" + scope.row[item.prop]
                                        : "--"
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
          _c("el-pagination", {
            staticStyle: { margin: "10px 0", float: "right" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.queryForm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("packageDetail", { ref: "packageDetailRef", attrs: { dataobj: {} } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }